/**
 * What the teacher writes in red: a grade on the Ukrainian 12-point scale in the
 * margin and a short note under the grid. Pure, so the wording is tested.
 */

export type NotebookStatus = "playing" | "won" | "lost";

/** 1 guess = 12 … 6 guesses = 7; a loss is the classic «2». Null while playing. */
export function gradeFor(status: NotebookStatus, attempts: number): number | null {
  if (status === "lost") return 2;
  if (status !== "won") return null;
  return Math.max(7, 13 - Math.max(1, attempts));
}

const PRAISE = ["Геніально!", "Відмінно!", "Молодець!", "Добре!", "Непогано!", "На межі!"];

export interface TeacherNote {
  text: string;
  /** "red" = the teacher's pen; "pencil" = a quiet hint. */
  pen: "red" | "pencil";
}

/**
 * The line under the grid. A rejection (`reject`) wins while it's fresh; then
 * the verdict once the game is over; a pencil reminder on the last try.
 */
export function teacherNote(
  status: NotebookStatus,
  attempts: number,
  answer: string | undefined,
  reject: string | null,
): TeacherNote | null {
  if (reject) return { text: reject, pen: "red" };
  if (status === "won") return { text: PRAISE[Math.max(1, attempts) - 1] ?? "Молодець!", pen: "red" };
  if (status === "lost") return { text: answer ? `Слово: ${answer}. До дошки!` : "До дошки!", pen: "red" };
  if (attempts === 5) return { text: "остання спроба…", pen: "pencil" };
  return null;
}
